"use client";

import { createContext } from "react";

const debugContext = createContext({
  debugMode: false,
  setDebugMode: (value: boolean) => {},
});

export default debugContext;
